import { gql } from 'graphql-request'

export namespace ScheduledCommunicationTemplatesQueries {
  export const QUERY_KEY = 'getScheduledCommunicationTemplates'

  export function getScheduledCommunicationTemplates() {
    return gql`
      query getScheduledCommunicationTemplates($filter: ScheduledCommunicationTemplateFilter) {
        scheduledCommunicationTemplates(filter: $filter) {
          ...ScheduledCommunicationTemplateSummary
        }
      }
      ${ScheduledCommunicationTemplatesQueries.SCHEDULED_COMMUNICATION_TEMPLATE_SUMMARY}
    `
  }

  export const SCHEDULED_COMMUNICATION_TEMPLATE_SUMMARY = gql`
    fragment ScheduledCommunicationTemplateSummary on ScheduledCommunicationTemplate {
      id
      active
      marketSegment
      scheduledCommunicationType
      content
    }
  `
}
